import { useEffect } from 'react';

const SaveCompanyCookie = () => {
  useEffect(() => {
    // Get query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const company = urlParams.get('company');

    if (company) {
      // Set cookie with ~100 year expiration
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 100);
      document.cookie = `company=${encodeURIComponent(
        company
      )}; expires=${expires.toUTCString()}; path=/`;
    }
  }, []);

  return null; // no UI, just runs in background
};

export default SaveCompanyCookie;
